import Controller from "./variablePlan.controller";
import template from "./variablePlan.html";

const variablePlan = {
  template,
  controller: Controller,
};

export default variablePlan;



// WEBPACK FOOTER //
// ./src/pages/variablePlan/variablePlan.component.js